import React from "react";
import styled from "styled-components";

const NavLink = ({ href, icon, children }) => {
  return (
    <StyledNavLink href={href}>
      {/* <Icon src={icon} alt={`${icon}`} /> */}
      {icon}
    </StyledNavLink>
  );
};

export default NavLink;

const StyledNavLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.text};
  padding: 0px 3px;
  /* transition: ${({ theme }) => theme.body} var(500ms); */
  /* width: 32px; */
  /* border-radius: 50%; */
  /* margin-left: 3px; */
  &:hover {
    /* background-color: ${({ theme }) => theme.accent}; */
    border-bottom: 1px solid ${({ theme }) => theme.accent}
  }
`;

const Icon = styled.img``;
